import type { FaqPublicCategory, LicenceCsm } from '@shared/schemas';

import type { CsmMessageStatus } from '@/features/licence/_shared/ui/contact-csm-dialog.view';

export type LoadStatus = 'idle' | 'loading' | 'loaded' | 'failed';

/**
 * Redux state for the client FAQ page (#735).
 *
 * `categories` is `GET /faq` as served: visible categories holding a published
 * question, published questions only, in display order. `csm` is who the
 * "Contact My Customer Success Manager" form writes to; null when the licence
 * has none or it could not be read, and the page then offers no contact. The
 * search, the open questions and the deep-link highlight stay local to the page.
 */
export interface ClientFaqState {
  categories: FaqPublicCategory[];
  loadStatus: LoadStatus;
  csm: Pick<LicenceCsm, 'first_name' | 'last_name'> | null;
  csmMessage: { status: CsmMessageStatus; error: string | null };
}

export const initialState: ClientFaqState = {
  categories: [],
  loadStatus: 'idle',
  csm: null,
  csmMessage: { status: 'idle', error: null },
};
